// src/pages/SellerSuccess/ErrorState.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sellerSuccessStyles } from './styles';

// Error icon
const AlertTriangleIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
    <line x1="12" y1="9" x2="12" y2="13"></line>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
);

const ErrorState = ({ error }) => {
  const navigate = useNavigate();
  const [buttonHover, setButtonHover] = useState(false);

  const handleRetry = () => {
    navigate('/seller-onboarding');
  };

  return (
    <div style={sellerSuccessStyles.statusContent}>
      <div style={sellerSuccessStyles.heroSection}>
        <div style={sellerSuccessStyles.errorIconContainer}>
          <AlertTriangleIcon />
        </div>
        <h1 style={sellerSuccessStyles.title}>Setup Verification Failed</h1>
        <p style={sellerSuccessStyles.description}>
          We encountered an issue while verifying your seller account setup. 
          Don't worry, this can usually be resolved quickly.
        </p>
      </div>

      {error && (
        <div style={sellerSuccessStyles.errorDetail}>
          <strong>Error Details:</strong> {error}
        </div>
      )}

      <div style={sellerSuccessStyles.ctaSection}>
        <button 
          onClick={handleRetry}
          onMouseEnter={() => setButtonHover(true)}
          onMouseLeave={() => setButtonHover(false)}
          style={{
            ...sellerSuccessStyles.retryButton,
            ...(buttonHover ? sellerSuccessStyles.retryButtonHover : {})
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23,4 23,10 17,10"></polyline>
            <polyline points="1,20 1,14 7,14"></polyline>
            <path d="M20.49 9A9 9 0 0 0 5.64 5.64l-.85.85"></path>
            <path d="M3.51 15a9 9 0 0 0 14.85 3.36l.85-.85"></path>
          </svg>
          Try Setup Again
        </button>
      </div>
    </div>
  );
};

export default ErrorState;